<div class="container-box">
  <app-table-header tableTitle="Banche" (btnUpdateClick)="loadBankAccount()">
    <app-button-new-bank-account action-button></app-button-new-bank-account>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="bankAccountTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
